import { Component } from '@angular/core';
import { RaisedTicketService } from '../../services/raised-ticket.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';

@Component({
  selector: 'app-raised-ticket',
  templateUrl: './raised-ticket.component.html',
  styleUrls: ['./raised-ticket.component.css']
})
export class RaisedTicketComponent {
  tickets :any= [];


  ticket = {
    title: '',
    description: '',
    requestId:'',
    CartId:''
  };
  email:any
  constructor(private ticketService: RaisedTicketService,private ToastmsgService:ToastmsgService,private UserInfoService:UserInfoService) {

    this.email=this.UserInfoService.getUsername();
    this.onAirClick()
  }
  ngOnInit() {
    // this.ticketService.getTickets().subscribe(data => {
    //   this.tickets = data;
    // });
  }
  disabled:boolean=false
  onSubmit(){


    let request= {
      "ticketSource": "Pragyan",
      "entity": {
          "entityCode": "GILPIN"
      },
      "project": {
          "projectCode": "PRAGYAN"
      },
      "ticketCategory": {
          "name": "Support"
      },
      "raisedBy" : this.email,
      "ticketInfo": {
          "ticketSummary": this.ticket?.title,
          "ticketDescription": this.ticket?.description,
          "customFieldList" : 
            {"cartId" : this.ticket.CartId,
            "requestId": this.ticket.requestId}
        
      }
      
  }
    this.disabled=true

    this.ticketService.addTicket(request,this.selectedFile)
    .subscribe({
      next : (res) => {
        this.disabled=false

        if(res.status==200 || res.status==201) {
          this.ToastmsgService.setMsg({msg : "Raise Ticket Successfully!",msgTitle : "Success", msgType : "I"});
          // this.dataFields()
       this.ticket = {
        title: '',
        description: '',
        requestId:'',
        CartId:''
      };
      this.fileName = '';
      this.selectedFile=null

        } else {
          const body : any = res.body;
        } 

      },error : (err) => {
        this.disabled=false


        this.ToastmsgService.setMsg({msg : "Failed to Raise Ticket",msgTitle : "Warning", msgType : "W"});
      }
    }
  )
 
}

Disabled(){
  if(this.ticket.description&&this.ticket.title){
    return true
  }    return false

}


  fileName: string = '';
  selectedFile:any=null
  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0] ?? null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.fileName = file.name;
    }

    console.log(this.fileName)
  }
showAir:boolean=false
  onAirClick(){
    this.showAir=true
  }
  backClick(){
    // window.location.href="/app/settings"
    window.location.href='/app/flight'
 
       } 
}
